import React, { useEffect, useRef, useState } from "react";
import { getReq } from "../middleware/AxiosApisCall";
// import { MdModeEditOutline } from "react-icons/md";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'

const RefillSheet = () => {
  // https://officejeeves.com/api/allrefillingrequest?refillerName=Vinod&date=2023-09-30
  const [totalSheet, setTotalSheet] = useState([]);
  
  
  const userName = localStorage.getItem("username");
  const isDate = new Date();
  const todayDate = isDate.toISOString().split("T")[0];
  //  const prev='2023-10-04'
  const refillerRefilledSheets = async () => {
    const response = await getReq(
      `allrefillingrequest?refillerName=${userName}&date=${todayDate}`
    );
    if (response?.data) {
      setTotalSheet(response.data.reverse());
    }
  };

  const refillerRillingdata = useRef(refillerRefilledSheets);
  useEffect(() => {
    refillerRillingdata.current();
  }, []);

  const formateDate = (isdate) => {
    const date = new Date(isdate);
    return date.toLocaleString();
  };

 

  return (
    <div style={{ marginTop: "30px" }}>
      <h3>Today Completed Refill Sheet</h3>
      <div className="input-lable-v-div">
        <label htmlFor="contactPerson">Date</label>
        <input
          type="date"
          name="text"
          value={todayDate}
          style={{ cursor: "not-allowed" }}
          readOnly
          
        />
      </div>

      <div className="table_container-div">
        {totalSheet.length > 0 ? (
          <TableContainer component={Paper}>
          <Table>
            <TableHead>
             <StyledTableRow>
                <HeaderTableCell>SL No</HeaderTableCell>
                <HeaderTableCell>Refiller Name</HeaderTableCell>
                <HeaderTableCell>Machine ID</HeaderTableCell>
                <HeaderTableCell>Machine Name</HeaderTableCell>
                <HeaderTableCell>Status</HeaderTableCell>
                <HeaderTableCell>Date & Time</HeaderTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
            {totalSheet.map((item, i) => {
              return (
                
                  <StyledTableRow key={i} sx={{backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',}}>
                    <StyledTableCell align="center">{i + 1}</StyledTableCell>
                    <StyledTableCell>{item.refillerName}</StyledTableCell>
                    <StyledTableCell>{item.machine}</StyledTableCell>
                    <StyledTableCell>{item.machineName}</StyledTableCell>
                    <StyledTableCell style={item.status==='Approved' ? {color:'#00ff00' }:{color:'#ff0000'}}>{item.status}</StyledTableCell>
                    <StyledTableCell>{formateDate(item.date)}</StyledTableCell>
                    {/* <td>
                        <MdModeEditOutline
                          className="Edit-icon"
                         
                        />
                        </td> */}
                  </StyledTableRow>
                
              );
            })}
            </TableBody>
          </Table>
          </TableContainer>
        ) : (
          <table>
            <tbody>
              <tr>
                <td> Data Not Found </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default RefillSheet;
